import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { customScrollStyles } from '@gem/ui-kit';

import { AppearanceExample } from '../../components/Appearance/AppearanceExample/AppearanceExample';
import { ChatBackgroundSelection } from '../../components/Appearance/ChatBackgroundSelection/ChatBackgroundSelection';
import { useAppearanceSettingsPopupPresenter } from './AppearanceSettingsPopup.presenter';
import styles from './AppearanceSettingsPopup.styles.m.css';
import { ThemeSelection } from './ThemeSelection/ThemeSelection';

export const AppearanceSettingsPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useAppearanceSettingsPopupPresenter(props);

  return (
    <Popup
      title={t('chat_appearance')}
      isOpened
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <div className={classNames(styles.container, customScrollStyles.container)}>
        <AppearanceExample previewBackground={presenter.activeChatBackground} />

        <ChatBackgroundSelection
          activeChatBackground={presenter.activeChatBackground}
          onChatBackgroundChange={presenter.onChatBackgroundChange}
        />

        <ThemeSelection
          activeTheme={presenter.activeTheme}
          onChange={presenter.onThemeChange}
        />
      </div>
    </Popup>
  );
});
